import { TimeSheetTypes } from '../ActionTypes/TimeSheetTypes';

let initialSate = {
    TimeSheetCleanerList: [],
    TimeSheetCleanerListPagination: null,
    TimeSheetList: [],
    TimeSheetListPagination: null,
};

const TimeSheetReducer = (state = initialSate, action) => {
    switch (action.type) {

        case TimeSheetTypes.GET_TIME_SHEET_CLEANER:
            let TimeSheetCleanerList_Copy = [];
            TimeSheetCleanerList_Copy = [
                ...state.TimeSheetCleanerList,
                ...action.payload.data,
            ];
            state = {
                ...state,
                TimeSheetCleanerListPagination: action.payload,
                TimeSheetCleanerList: TimeSheetCleanerList_Copy
            };
            break;

        case TimeSheetTypes.CLEAR_TIME_SHEET_CLEANER:
            state = {
                ...state,
                TimeSheetCleanerListPagination: null,
                TimeSheetCleanerList: []
            };
            break;

        case TimeSheetTypes.GET_TIME_SHEET:
            let TimeSheetList_Copy = [];
            TimeSheetList_Copy = [
                ...state.TimeSheetList,
                ...action.payload.data,
            ];
            state = {
                ...state,
                TimeSheetListPagination: action.payload,
                TimeSheetList: TimeSheetList_Copy
            };
            break;

        case TimeSheetTypes.CLEAR_TIME_SHEET:
            state = {
                ...state,
                TimeSheetListPagination: null,
                TimeSheetList: []
            };
            break;
    }
    return state;
};

export default TimeSheetReducer;
